import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);
function dataDownline(params) {
	return client.post("user/affiliate/data-downline", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function historyCoinGen(params) {
	return client.post("user/transaction/history-coin-gen", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function checkoutTrxFullCoinGen(params) {
	return client.post("user/transaction/check-out-full-coin-gen", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function checkoutTrx(params) {
	return client.post("user/transaction/check-out", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkoutTrxStore(params) {
	return client.post("user/transaction/check-out-store", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkoutTrxVABCA(params) {
	return client.post("user/transaction/check-out-va", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getHistoryNego(params) {
	return client.get("user/transaction/data_history_nego", {
		params: params,
	});
}
function getTransaction(params) {
	return client.get("user/transaction/data", {
		params: params,
	});
}
function getExcelHistoryNego(params) {
	return client.get("user/transaction/export_history_nego", {
		params: params,
	});
}
function getStatisticTempoPayment(params) {
	return client.get("user/transaction/statistic-payment", {
		params: params,
	});
}

function getTransactionDetail(params) {
	return client.get("user/transaction/detail", {
		params: params,
	});
}
function updateHargaNego(params) {
	return client.post("user/transaction/nego_items", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelTransaction(params) {
	return client.post("user/transaction/cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelBank(params) {
	return client.post("user/transaction/cancel-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}
function cancelStore(params) {
	return client.post("user/transaction/cancel-store", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelVA(params) {
	return client.post("user/transaction/cancel-va", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function receiveTransaction(params) {
	return client.post("user/transaction/receive", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadConfirmation(params) {
	return client.post("user/transaction/pay", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}
function uploadCSSumbit(params) {
	return client.post("user/transaction/cs_submit", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}
function historyUploadTermin(params) {
	return client.get("user/transaction/data-payment", {
		params: params,
	});
}

export default {
	dataDownline,
	checkoutTrx,
	checkoutTrxStore,
	checkoutTrxVABCA,
	uploadCSSumbit,
	getTransaction,
	getTransactionDetail,
	getExcelHistoryNego,
	cancelTransaction,
	cancelBank,
	cancelStore,
	cancelVA,
	historyUploadTermin,
	receiveTransaction,
	getHistoryNego,
  getStatisticTempoPayment,
	uploadConfirmation,
	checkoutTrxFullCoinGen,
	historyCoinGen,
	updateHargaNego,
};
